import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Vision from '../components/Vision';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Hero />
      <About />
      <Vision />
    </div>
  );
};

export default HomePage;
